import React, { useContext, useEffect, useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';
import config from "../../envconfig";
import axios from "axios"
import { UserContext } from '../common/UserContext';
import { encryptUrl } from "../common/cryptoUrl";
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';
import CustomSingleValue from '../common/CustomSingleValue';

function CompanyMaster() {
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);

  const [formdata, setFormdata] = useState({
    CM_CompanyCode: '',
    CM_CompanyName: '',
    CM_CompanyGrpId: '',
    CM_Status: 1,
  });
  const [errors, setErrors] = useState({
    required: {
      CM_CompanyCode: '',
      CM_CompanyName: '',
      CM_CompanyGrpId: '',
    },
    other: {
      CM_CompanyCode: '',
      CM_CompanyName: '',
      CM_CompanyGrpId: '',
    },
  });
  const [selectedOption, setSelectedOption] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const toastRef = useRef(null);
  const showToast = (type, message, options = {}) => {
    if (toastRef.current && toast.isActive(toastRef.current)) {
      toast.update(toastRef.current, {
        render: message,
        type,
        autoClose: 3000,
        ...options,
      });
    } else {
      toastRef.current = toast[type](message, {
        autoClose: 3000,
        ...options,
      });
    }
  };
  useEffect(() => {
    const auditTrailOnListAccess = async () => {
      const currentTimestamp = new Date().toISOString();
      const data = {
        AUTR_ScreenName: 'Company Msater',
        AUTR_OldValue: null,
        AUTR_NewValue: null,
        AUTR_Message: 'Navigated to Company List',
        AUTR_UserID: UM_UserId,
        AUTR_UserName: UM_UserCode,
        AUTR_TimeStamp: currentTimestamp,
        AUTR_AuditType: 'Navigation',
        AUTR_SCPID: selectedScpId,
        AUTR_CompanyGrpId: UM_CompanyGrpID,
        AUTR_CompanyID: UM_CompanyID,
        AUTR_CreatedBy: UM_UserId,
        AUTR_CreatedDateTime: currentTimestamp,
      };

      try {
        const response = await axios.post(`${config.API_URL}/api/audittrail`, data);
        console.log('Audit Trail Success:', response.data);
      } catch (error) {
        console.error('Audit Trail Error:', error);
      }
    };

    if (UM_GroupId && UM_CompanyID) {
      auditTrailOnListAccess();
    }
  }, [UM_GroupId, UM_CompanyID, UM_CompanyGrpID, UM_UserId, UM_UserCode, selectedScpId]);

  const audittransection = async (data) => {
    const formData = {
      AUTRN_ID: data.AUTRN_ID,
      AUTRN_OldValue: data.AUTRN_OldValue ?? null,
      AUTRN_NewValue: data.AUTRN_NewValue,
      AUTRN_ParamererName: data.AUTRN_ParamererName
    };
    try {
      const response = await axios.post(`${config.API_URL}/api/audittransaction`, formData);
    } catch (error) {
      if (error.response) {
        console.error('Server responded with an error:', error.response.data);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error setting up the request:', error.message);
      }
    }
  }

  const audittrailpost = async (details) => {
    const getCurrentTimestamp = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const currentTimestamp = getCurrentTimestamp();
    const AUTR_OldValue = details?.AUTR_OldValue ?? null;
    const AUTR_NewValue = details?.AUTR_NewValue ?? null;
    const AUTR_Message = details.AUTR_Message ?? '-';
    const AUTR_AuditType = details.AUTR_AuditType ?? 'Unknown';

    const data = {
      AUTR_ScreenName: "Company Master",
      AUTR_OldValue: AUTR_OldValue,
      AUTR_NewValue: AUTR_NewValue,
      AUTR_Message: AUTR_Message,
      AUTR_UserID: UM_UserId ?? null,
      AUTR_UserName: UM_UserCode ?? null,
      AUTR_TimeStamp: currentTimestamp,
      AUTR_AuditType: AUTR_AuditType,
      AUTR_SCPID: selectedScpId ?? null,
      AUTR_CompanyGrpId: UM_CompanyGrpID ?? null,
      AUTR_CompanyID: UM_CompanyID ?? null,
      AUTR_CreatedBy: UM_UserId ?? null,
      AUTR_CreatedDateTime: currentTimestamp
    };

    try {
      const response = await axios.post(`${config.API_URL}/api/audittrail`, data);
      console.log('Success:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ module: "Company Master:", action, userCode: UM_UserCode, isError }),
      });

      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);
    sessionStorage.setItem('selectedScpId', selectedScpId);
  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);

  const [message, setMessage] = useState('');
  const [groups, setGroups] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);

  // Status options for React Select
  const statusOptions = [
    { value: 1, label: 'Active' },
    { value: 2, label: 'Inactive' },
  ];

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const response = await fetch(`${config.API_URL}/activecompanygroupname`);
        const data = await response.json();
        console.log("CGM_CompanyGroupName data ", data)
        if (response.ok) {
          if (data.CGM_ID) {
            setGroups(data.CGM_ID);

            const options = data.CGM_ID.map(group => ({
              value: group.CGM_ID,
              label: group.CGM_CompanyGroupName
            }));
            setGroupOptions(options);
          } else {
            console.error('Invalid API response:', data);
            logAction('fetchGroups():Invalid API response')
          }
        } else {
          console.error('Error fetching group data. Server returned:', response.status);
          logAction('fetchGroups():Error fetching group data')
        }
      } catch (error) {
        console.error('Failed to fetch group data:', error);
        logAction('fetchGroups():Failed to fetch group data. Please check your network connection')
      }
    };
    logAction('fetchGroups():Ended')
    fetchGroups();
  }, []);

  const validateForm = () => {
    let valid = true;
    const newErrors = {
      required: { ...errors.required },
      other: { ...errors.other },
    };
    logAction('validateForm():Started')

    // Validate CM_CompanyName
    if (!formdata.CM_CompanyName) {
      newErrors.required.CM_CompanyName = '*';
      newErrors.other.CM_CompanyName = '';
      valid = false;
    } else if (!/^[a-zA-Z0-9]$/.test(formdata.CM_CompanyName[0])) {
      newErrors.other.CM_CompanyName = 'The first characters must be alphanumeric';
      valid = false;
      logAction('validateForm():The first characters must be alphanumeric', true)
    } else if (!/^[a-zA-Z0-9.]$/.test(formdata.CM_CompanyName.slice(-1))) {
      newErrors.other.CM_CompanyName = 'The last character must be alphanumeric or a dot (.)';
      valid = false;
      logAction('validateForm():The last character must be alphanumeric or a dot (.)', true)
    } else if (!/^[a-zA-Z0-9_\- .&]+$/.test(formdata.CM_CompanyName)) {
      newErrors.other.CM_CompanyName = 'Please use only special characters like -, _, ., & and space';
      valid = false;
      logAction('validateForm():Please use only special characters like -, _, ., & and space', true)
    } else if (/([_\-.&]{2,})| {2,}/.test(formdata.CM_CompanyName)) {
      newErrors.other.CM_CompanyName = 'Consecutive special characters are not allowed';
      valid = false;
      logAction('validateForm() Consecutive special characters are not allowed', true)
    } else if (formdata.CM_CompanyName.length > 45) {
      newErrors.other.CM_CompanyName = 'Maximum length is 45 characters';
      valid = false;
      logAction('validateForm():Maximum length is 45 characters', true);
    } else {
      newErrors.required.CM_CompanyName = '';
      newErrors.other.CM_CompanyName = '';
    }

    // Validate CM_CompanyCode
    if (!formdata.CM_CompanyCode) {
      newErrors.required.CM_CompanyCode = '*';
      newErrors.other.CM_CompanyCode = '';
      valid = false;
    } else if (!/^[a-zA-Z0-9]$/.test(formdata.CM_CompanyCode[0]) || !/^[a-zA-Z0-9]$/.test(formdata.CM_CompanyCode.slice(-1))) {
      newErrors.other.CM_CompanyCode = 'The first and last characters must be alphanumeric';
      valid = false;
      logAction('validateForm():The first and last characters must be alphanumeric', true)
    } else if (!/^[a-zA-Z0-9_\- ]+$/.test(formdata.CM_CompanyCode)) {
      newErrors.other.CM_CompanyCode = 'Please use only special characters like -, _ and space';
      valid = false;
      logAction('validateForm():Please use only special characters like -, _ and space', true)
    } else if (/([_\-]{2,})| {2,}/.test(formdata.CM_CompanyCode)) {
      newErrors.other.CM_CompanyCode = 'Consecutive special characters are not allowed';
      valid = false;
      logAction('validateForm():Consecutive special characters are not allowed', true)
    } else if (formdata.CM_CompanyCode.length > 45) {
      newErrors.other.CM_CompanyCode = 'Maximum length is 45 characters';
      valid = false;
      logAction('validateForm():Maximum length is 45 characters', true);
    } else {
      newErrors.required.CM_CompanyCode = '';
      newErrors.other.CM_CompanyCode = '';
    }

    // Validate CM_CompanyGrpId
    if (!formdata.CM_CompanyGrpId) {
      newErrors.required.CM_CompanyGrpId = '*';
      valid = false;
    } else {
      newErrors.required.CM_CompanyGrpId = '';
      newErrors.other.CM_CompanyGrpId = '';
    }

    logAction('validateForm():Ended')
    setErrors(newErrors);
    return valid;
  };

  // Handle Company Group Select change
  // const handleGroupSelectChange = (selectedOption) => {
  //   logAction('handleGroupSelectChange():Started')

  //   const selectedGroup = groups.find(group => group.CGM_ID === selectedOption?.value);

  //   setFormdata(prev => ({
  //     ...prev,
  //     CM_CompanyGrpId: selectedOption?.value || ''
  //   }));

  //   setErrors(prev => ({
  //     ...prev,
  //     required: {
  //       ...prev.required,
  //       CM_CompanyGrpId: ''
  //     },
  //     other: {
  //       ...prev.other,
  //       CM_CompanyGrpId: ''
  //     }
  //   }));

  //   logAction(`handleGroupSelectChange():Selected Company Group - ${selectedGroup?.CGM_CompanyGroupName || 'None'}`);
  // };
  const handleGroupSelectChange = (selectedOption) => {
    logAction('handleGroupSelectChange():Started');

    setSelectedOption(selectedOption); // Add this line

    const selectedGroup = groups.find(group => group.CGM_ID === selectedOption?.value);

    setFormdata(prev => ({
      ...prev,
      CM_CompanyGrpId: selectedOption?.value || ''
    }));

    setErrors(prev => ({
      ...prev,
      required: {
        ...prev.required,
        CM_CompanyGrpId: ''
      },
      other: {
        ...prev.other,
        CM_CompanyGrpId: ''
      }
    }));

    logAction(`handleGroupSelectChange():Selected Company Group - ${selectedGroup?.CGM_CompanyGroupName || 'None'}`);
  };
  // Handle Status Select change
  const handleStatusSelectChange = (selectedOption) => {
    logAction('handleStatusSelectChange():Started')

    setFormdata(prev => ({
      ...prev,
      CM_Status: selectedOption?.value || 1
    }));

    logAction(`handleStatusSelectChange():Selected Status - ${selectedOption?.label || 'Active'}`);
  };
const handleBlur = (e) => {
  const { name, value } = e.target;

  setFormdata((prevData) => ({
    ...prevData,
    [name]: value.trimEnd(), // 🔥 only remove trailing space
  }));
};
  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormdata((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    let valid = true;
    const newErrors = {
      required: { ...errors.required },
      other: { ...errors.other },
    };

    // Validate CM_CompanyName
    if (name === 'CM_CompanyName') {
      if (!value) {
        newErrors.other.CM_CompanyName = '';
        valid = false;
      } else if (!/^[a-zA-Z0-9]$/.test(value[0])) {
        newErrors.other.CM_CompanyName = 'The first characters must be alphanumeric';
        valid = false;
        logAction('handleInput():The first characters must be alphanumeric', true)
      } else if (!/^[a-zA-Z0-9. ]$/.test(value[value.length - 1])) {
        newErrors.other.CM_CompanyName = 'The last character must be alphanumeric or a dot (.)';
        valid = false;
        logAction('handleInput():The last character must be alphanumeric or a dot (.)', true)
      } else if (!/^[a-zA-Z0-9_\- .&]+$/.test(value)) {
        newErrors.other.CM_CompanyName = 'Please use only special characters like -, _, ., & and space';
        valid = false;
        logAction('handleInput():Please use only special characters like -, _, . and space', true)
      // } else if (/([_\-.&]{2,})| {2,}/.test(value)) {
      } else if (/([_\-.&]{2,})/.test(value) || / {2,}(?=\S)/.test(value)) {
        newErrors.other.CM_CompanyName = 'Consecutive special characters are not allowed';
        valid = false;
        logAction('handleInput(): Consecutive special characters are not allowed', true)
      } else if (value.length > 45) {
        newErrors.other.CM_CompanyName = 'Maximum length is 45 characters';
        valid = false;
      } else {
        newErrors.required.CM_CompanyName = '';
        newErrors.other.CM_CompanyName = '';
      }
    }

    // Validate CM_CompanyCode
    if (name === 'CM_CompanyCode') {
      if (!value) {
        newErrors.other.CM_CompanyCode = '';
        valid = false;
      } else if (!/^[a-zA-Z0-9]$/.test(value[0]) || !/^[a-zA-Z0-9 ]$/.test(value[value.length - 1])) {
        newErrors.other.CM_CompanyCode = 'The first and last characters must be alphanumeric';
        valid = false;
        logAction('handleInput():The first and last characters must be alphanumeric', true)
      } else if (!/^[a-zA-Z0-9_\- ]+$/.test(value)) {
        newErrors.other.CM_CompanyCode = 'Please use only special characters like -, _ and space';
        valid = false;
        logAction('handleInput():Please use only special characters like -, _ and space', true)
      // } else if (/([_\-]{2,})| {2,}/.test(value)) {
      } else if (/([_\-]{2,})/.test(value) || / {2,}(?=\S)/.test(value)) {
        newErrors.other.CM_CompanyCode = 'Consecutive special characters are not allowed';
        valid = false;
        logAction('handleInput(): Consecutive special characters are not allowed', true)
      } else if (value.length > 45) {
        newErrors.other.CM_CompanyCode = 'Maximum length is 45 characters';
        valid = false;
      } else {
        newErrors.required.CM_CompanyCode = '';
        newErrors.other.CM_CompanyCode = '';
      }
    }

    setErrors(newErrors);
    if (!valid) {
      return;
    }
    setFormdata({ ...formdata, [name]: value });
    setMessage('');
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validateForm()) {
  //     return;
  //   }

  //   try {
  //     const encryCompnayCode = encryptUrl(formdata.CM_CompanyCode);
  //     console.log("encryCompnayCode:", encryCompnayCode);

  //     const requestOptions = {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         ...formdata,
  //         CGM_CreatedBy: UM_UserId,
  //         CGM_ModifiedBy: UM_UserId,
  //         CM_CompanyUrl: encryCompnayCode,
  //       }),
  //     };

  //     const response = await fetch(`${config.API_URL}/company_master`, requestOptions);
  //     const data = await response.json();

  //     if (!response.ok) {
  //       throw new Error(data.error || 'Failed to insert data');
  //     }

  //    setErrors({
  //       required: "",
  //       other: ""
  //     })

  //     logAction(`Company : ${formdata.CM_CompanyName} saved successfully`);

  //     const details = {
  //       AUTR_Message: `${formdata.CM_CompanyName} saved successfully`,
  //       AUTR_AuditType: "insert",
  //       AUTRN_NewValue: formdata.CM_CompanyName
  //     };
  //     let id = await (audittrailpost(details));
  //     const cgname = {
  //       AUTRN_ParamererName: "CM_CompanyName",
  //       AUTRN_NewValue: formdata.CM_CompanyName,
  //       AUTRN_ID: id
  //     }

  //     const status = {
  //       AUTRN_ParamererName: "CM_Status",
  //       AUTRN_NewValue: (formdata.CM_Status === 1) ? "Active" :
  //         (formdata.CM_Status === 2) ? "Inactive" : "Unknown",
  //       AUTRN_ID: id
  //     }

  //     const cgcode = {
  //       AUTRN_ParamererName: "CM_CompanyCode",
  //       AUTRN_NewValue: formdata.CM_CompanyCode,
  //       AUTRN_ID: id
  //     }

  //     const selectedGroup = groups.find(group => group.CGM_ID === formdata.CM_CompanyGrpId);
  //     if (selectedGroup) {
  //       const details = {
  //         AUTRN_ParamererName: "CM_CompanyGrpId",
  //         AUTRN_NewValue: selectedGroup.CGM_CompanyGroupName,
  //         AUTRN_ID: id
  //       }
  //       audittransection(details)
  //     }

  //     audittransection(cgname)
  //     audittransection(status)
  //     audittransection(cgcode)

  //     showToast('success',`Company : ${formdata.CM_CompanyName} saved successfully.`,{
  //       onClose : () => {
  //             setFormdata({
  //       CM_CompanyCode: '',
  //       CM_CompanyName: '',
  //       CM_CompanyGrpId: '',
  //       CM_Status: 1,
  //     });
  //       }
  //     });

  //   } catch (error) {
  //     logAction(`Error inserting data: ${error.message}`, true);
  //     showToast('error',error.message);
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      // ✅ Disable form immediately
      setIsLoading(true);

      const encryCompnayCode = encryptUrl(formdata.CM_CompanyCode);

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formdata,
          CGM_CreatedBy: UM_UserId,
          CGM_ModifiedBy: UM_UserId,
          CM_CompanyUrl: encryCompnayCode,
        }),
      };

      const response = await fetch(
        `${config.API_URL}/company_master`,
        requestOptions
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to insert data");
      }

      setErrors({
        required: "",
        other: "",
      });

      logAction(
        `Company : ${formdata.CM_CompanyName} saved successfully`
      );

      const details = {
        AUTR_Message: `${formdata.CM_CompanyName} saved successfully`,
        AUTR_AuditType: "insert",
        AUTRN_NewValue: formdata.CM_CompanyName,
      };

      let id = await audittrailpost(details);

      audittransection({
        AUTRN_ParamererName: "CM_CompanyName",
        AUTRN_NewValue: formdata.CM_CompanyName,
        AUTRN_ID: id,
      });

      audittransection({
        AUTRN_ParamererName: "CM_Status",
        AUTRN_NewValue:
          formdata.CM_Status === 1
            ? "Active"
            : formdata.CM_Status === 2
              ? "Inactive"
              : "Unknown",
        AUTRN_ID: id,
      });

      audittransection({
        AUTRN_ParamererName: "CM_CompanyCode",
        AUTRN_NewValue: formdata.CM_CompanyCode,
        AUTRN_ID: id,
      });

      const selectedGroup = groups.find(
        (group) => group.CGM_ID === formdata.CM_CompanyGrpId
      );

      if (selectedGroup) {
        audittransection({
          AUTRN_ParamererName: "CM_CompanyGrpId",
          AUTRN_NewValue: selectedGroup.CGM_CompanyGroupName,
          AUTRN_ID: id,
        });
      }

      // ✅ Keep form disabled until toast closes
      showToast(
        "success",
        `Company : ${formdata.CM_CompanyName} saved successfully.`,
        {
          autoClose: 3000,
          onClose: () => {
            setFormdata({
              CM_CompanyCode: "",
              CM_CompanyName: "",
              CM_CompanyGrpId: "",
              CM_Status: 1,
            });

            setIsLoading(false); // ✅ Enable form AFTER toast ends
          },
        }
      );

    } catch (error) {
      setIsLoading(false); // ✅ Enable immediately on error

      logAction(`Error inserting data: ${error.message}`, true);
      showToast("error", error.message);
    }
  };


  const handleCancel = () => {
    setFormdata({
      CM_CompanyName: '',
      CM_CompanyCode: '',
      CM_CompanyGrpId: '',
      CM_Status: 1,
    });
    setSelectedOption(""); // Clear the selectedOption state
    setErrors({
      required: "",
      other: ""
    })
    setMessage('');
  };

  // Get the currently selected values for React Select
  const selectedGroupValue = groupOptions.find(option => option.value === formdata.CM_CompanyGrpId);
  const selectedStatusValue = statusOptions.find(option => option.value === formdata.CM_Status);

  const [isSelectOpen, setIsSelectOpen] = useState(null);
  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
  };
  const handleSelectClose = () => {
    setIsSelectOpen(null);
  };

  return (
    <React.Fragment>
      <ToastContainer style={{
        marginTop: '73px',
        fontSize: '14px',
        width: '40%',
      }} />
      {isLoading && (
        <div style={{
          position: 'fixed', // Sit on top of the page content
          left: 0,
          top: 0,
          width: '100%', // Full width
          height: '100%', // Full height

          zIndex: 1000 // Sit on top of the other elements
        }} />
      )}
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className='main_container'>
          <h3 className=" formHeading">
            Company Master
          </h3>

          <div className='your-form-containe row'>
            {/* <div className='form-section'> */}
            <div className='label-input-containe col-md-6'>
              <div className='mt-2'>
                <label className='form-label'>Company Name <span className='text-danger  '>{errors.required.CM_CompanyName}</span></label>
                <input
                  type='text'
                  name='CM_CompanyName'
                  className='form-input'
                  placeholder=''
                  value={formdata.CM_CompanyName}
                  onChange={handleInput}
                   onBlur={handleBlur}
                  maxLength={45}
                />
                <div className="text-danger">{errors.other.CM_CompanyName}</div>
              </div>
            </div>
            <div className='label-input-containe col-md-6'>
              <div className='mt-2'>
                <label className='form-label'>Company Code <span className='text-danger  '>{errors.required.CM_CompanyCode}</span></label>
                <input
                  type='text'
                  name='CM_CompanyCode'
                  className='form-input'
                  placeholder=''
                  value={formdata.CM_CompanyCode}
                  onChange={handleInput}
                   onBlur={handleBlur}
                  maxLength={45}
                />
                <div className="text-danger">{errors.other.CM_CompanyCode}</div>
              </div>
            </div>

            <div className='label-input-containe col-md-6'>
              <div className='mt-1'>
                <label className='form-label'>Company Group Name <span className='text-danger   '>{errors.required.CM_CompanyGrpId}</span></label>
                <div className='select-container'>
                  <Select
                    key={formdata.CM_CompanyGrpId || "empty"} // Add this key
                    name='CM_CompanyGrpId'
                    placeholder='--Select--'
                    options={groupOptions}
                    value={selectedGroupValue}
                    onChange={handleGroupSelectChange}
                    isSearchable={true}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    onMenuOpen={() => handleSelectOpen("CM_CompanyGrpId")}
                    onMenuClose={handleSelectClose}
                    components={{ SingleValue: CustomSingleValue }}
                  />
                  <div className="icon-container_list myList">
                    {isSelectOpen === "CM_CompanyGrpId" ? (
                      <IoCaretUpOutline />
                    ) : (
                      <IoCaretDownOutline />
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className='label-input-containe col-md-6'>
              <div className='mt-1'>
                <label className='form-label'>Company Status <span className='text-danger  '>{errors.CM_Status}</span></label>
                <div className='select-container'>
                  <Select
                    name='CM_Status'
                    placeholder='--Select--'
                    options={statusOptions}
                    value={selectedStatusValue}
                    onChange={handleStatusSelectChange}
                    isClearable={false}
                    isSearchable={false}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    onMenuOpen={() => handleSelectOpen("CM_Status")}
                    onMenuClose={handleSelectClose}
                    components={{ SingleValue: CustomSingleValue }}
                  />
                  <div className="icon-container_list myList">
                    {isSelectOpen === "CM_Status" ? (
                      <IoCaretUpOutline />
                    ) : (
                      <IoCaretDownOutline />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <p className='text-success'>{message}</p>
            <p className='text-danger'>{errors.duplicateMsg}</p>
            {/* </div> */}
          </div>
        </div>
        <div className='button-container'>
          <button type='submit' className='save_btn'> SAVE </button>
          <button type='button' className='reset_btn' onClick={handleCancel}> RESET </button>
          <Link to={`/cmlist/`} className='list_btn' type='button'> LIST </Link>
        </div>
      </form>
    </React.Fragment>
  );
}

export default CompanyMaster;